<template>
    <v-container>
        <v-layout>
            <v-flex>
                <!-- products -->
                <ProductBuy
                    :getcartlist="cartlist"
                    :getseparateshippingdesc="separate_shippingdesc"
                    :getcartshippingfree="separate_shippingfree"
                    v-if="cartlist.length !== 0 && separate_shippingfree.length !== 0 && separate_shippingdesc.length !== 0"
                    @childsend="getChild"
                />
                <!-- coupon & star point -->
                <ProductCouponStar
                    :getusercheerpoint="userInfo[0].cheer_point"
                    v-if="cheer_point_limit !== null && total_shipping_fee !== null && price !== null && userInfo.length"
                />
                <!-- address -->
                <ProductAddress
                    :getuserinfodata="userInfo"
                    v-if="userInfo.length"
                />
                <!-- receipt -->
                <ProductReceipt
                    :getreceiptinfodata="userInfo"
                    v-if="userInfo.length"
                />
                <!-- PayType -->
                <ProductPayType />
                <!-- price -->
                <ProductPriceInfos
                    v-if="total_shipping_fee !== null && price !== null"
                />
                <!-- send order -->
                <sendOrderData />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    // import ProductInfo from '../components/productItems/ProductInfo.vue';
    import ProductBuy from '../components/productItems/ProductBuy.vue';
    import ProductCouponStar from '../components/productItems/ProductCouponStar.vue';
    import ProductAddress from '../components/productItems/ProductAddress.vue';
    import ProductReceipt from '../components/productItems/ProductReceipt.vue';
    import ProductPayType from '../components/productItems/ProductPayType.vue';
    import ProductPriceInfos from '../components/productItems/ProductPriceInfos.vue';
    import sendOrderData from '../components/productItems/sendOrderData.vue';

    export default {
        name: 'IsProduct',
        components: {
            ProductBuy,
            ProductCouponStar,
            ProductAddress,
            ProductReceipt,
            ProductPayType,
            ProductPriceInfos,
            sendOrderData
        },

        data: () => ({
            // 購物車
            cartlist: [],
            // 星幣可折抵上限
            cheer_point_limit: null,
            // 購物金可折抵上限
            shop_money_limit: null,
            // 全部運費的金額
            total_shipping_fee: null,
            // 個別最低標金額
            separate_shippingfree: [],
            // 是否到低標
            separate_shippingdesc: [],
            // 不包含運費總價
            price: null,
            // 使用者資訊
            userInfo: [],
        }),
        computed: {
        },
        methods: {
            getCartInfo() {
                this.axios({
                    method: 'post',
                    url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/productions/cart-list`,
                    data: {
                        access_key: process.env.VUE_APP_ACCESSKEY,
                        productions: this.$store.state.putcartlist.putcartData,
                    },
                })
                    .then((response) => {
                        this.cartlist = response.data.arr;
                        this.cheer_point_limit = response.data.cheer_point_limit;
                        this.shop_money_limit = response.data.shop_money_limit;
                        this.total_shipping_fee = response.data.total_shipping_fee;
                        this.separate_shippingfree = response.data.separate_shipping_free;
                        this.separate_shippingdesc = response.data.separate_shipping_desc;
                        this.price = response.data.price;
                        const shippingFee_price = {
                            'totalshippingfee': this.total_shipping_fee,
                            'separateshippingfree': this.separate_shippingfree,
                            'separateshippingdesc': this.separate_shippingdesc,
                            'price': this.price,
                            'oldprice': this.price,
                            'cheerpointlimit': this.cheer_point_limit,
                            'shopmoneylimit': this.shop_money_limit
                        }
                        // store vuex
                        this.$store.commit({
                            type: 'setShippingPriceData',
                            shippingpriceData: shippingFee_price,
                        });
                        // store vuex
                        this.$store.commit({
                            type: 'setGetCartData',
                            getcartData: this.cartlist,
                        });
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            },
            getUserInfo() {
                const uuid = sessionStorage.getItem('user_uuid');
                const token = sessionStorage.getItem('accessToken');
                this.axios({
                        method: 'post',
                        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/users/user-info`,
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        data: {
                            user_uuid: uuid
                        },
                    })
                    .then((response) => {
                        this.userInfo.push(response.data);
                        // 儲存使用者資訊
                        let userinfo_data = [];
                        userinfo_data.push(response.data);
                        // store vuex
                        this.$store.commit({
                            type: 'setUserinfoData',
                            userinfoData: userinfo_data,
                        });
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                        if (error.response.data.message === 'token過期') {
                            sessionStorage.setItem('accessToken', '');
                            sessionStorage.setItem('user_uuid', '');
                            document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            this.$router.go(-1);
                        }
                    });
            },
            getChild() {
                this.separate_shippingdesc = this.$store.state.shippingprice.shippingpriceData.separateshippingdesc;
            }
        },
        mounted() {
            this.getCartInfo();
            this.getUserInfo();
        },
        beforeDestroy() {
        },
    }
</script>

<style scoped lang="sass">
</style>
